module.exports = __webpack_public_path__ + "static/grafid_logo_black_big-756affeb470f608c3759c6edabf8543f.png";